<artemis-breadcrumbs [breadcrumbs]="breadcrumbs | async"></artemis-breadcrumbs>
<artemis-customer-overview-card></artemis-customer-overview-card>
<div class="customer-particulars-card">
  <div ubi-curve-header class="customer-particulars-card__header">
    <span class="customer-particulars-card__header-text">
      {{ 'customer_info.header' | translate }}
    </span>
  </div>
  <div class="customer-particulars-card__content-container">
    <artemis-loading-spinner *ngIf="loading$ | async"></artemis-loading-spinner>
    <div class="customer-particulars-card__hint-container" *ngIf="customer?.customer?.integrationStatus === 'UPDATED'">
      <img class="customer-particulars-card__hint-icon" src="/assets/icons/exclamation-icon-accent.png" />
      <div class="customer-particulars-card__hint-msg"> {{ 'customer_info.message.profile_has_been_updated' | translate }} </div>
    </div>
    <div class="customer-particulars-card__subsection customer-particulars-card__subsection_no-padding customer-particulars-card__subsection_no-border">
      <artemis-customer-particulars></artemis-customer-particulars>
    </div>
    <div class="customer-particulars-card__subsection" *ngIf="otherData">
      <div class="customer-particulars-card__subsection-title">
        {{ 'customer_info.title.other_info' | translate }}
      </div>
      <artemis-customer-other-data [rawOtherData]="otherData" [editMode]="false"></artemis-customer-other-data>
    </div>
    <div class="customer-particulars-card__btns-container">
      <div class="customer-particulars-card__edit-btn-group">
        <button mat-button class="btn btn_rounded customer-particulars-card__btn" ubi-round-button (click)="toEditPage()" *ngIf="customer?.customer">
          {{ 'customer_info.button.edit' | translate }}
        </button>
        <button mat-button class="btn btn_rounded customer-particulars-card__btn" ubi-round-button (click)="openRequireUpdateForm()" *ngIf="customer?.customer && enableAresIntegration">
          {{ 'customer_info.button.require_update' | translate }}
        </button>
        <button mat-button class="btn btn_rounded customer-particulars-card__btn" ubi-round-button (click)="addCRP()" *ngIf="customer?.customer?.customerType === 'CORPORATE'">
          {{ 'customer_info.button.add_crp' | translate }}
        </button>
      </div>
      <button mat-button class="btn btn_accent-gradient-rounded customer-particulars-card__btn customer-particulars-card__btn_screening" ubi-round-button (click)="checkBalance()" *ngIf="customer?.customer">
        {{ 'customer_info.button.submit_for_screening' | translate }}
      </button>
    </div>
  </div>
</div>
<artemis-crp-list-card></artemis-crp-list-card>
<div #customerDocument>
  <artemis-customer-document [record]="customer?.record"></artemis-customer-document>
</div>
<ng-template #requireUpdateForm>
  <div class="require-update-container">
    <div class="require-update__header">
      <div class="require-update__header-text">
        <img class="require-update__icon" src="/assets/icons/add-icon-secondary-font-color.png">
        <span class="require-update__label"> {{ 'requireUpdate.label.require_update' | translate }} </span>
      </div>
      <div class="require-update__close">
        <img class="themified-white-icon require-update__close-icon" src="/assets/icons/cross-icon.png" (click)="closeRequireUpdateModal()" />
      </div>
    </div>
    <div class="require-update__content">
      <div class="require-update__comment">
        <mat-form-field appearance="fill" class="custom-mat-form-field require-update__form-field">
          <mat-label> {{ 'requireUpdate.label.enter_message' | translate }} </mat-label>
          <textarea matInput rows="10" [(ngModel)]="requireUpdateContent"></textarea>
        </mat-form-field>
      </div>
      <div class="require-update__action">
        <button mat-button ubi-round-button class="btn btn_accent-gradient-rounded" (click)="requireUpdate()"
          [disabled]="requireUpdateContent === ''">
           {{ 'requireUpdate.button' | translate }}
        </button>
      </div>
    </div>
  </div>
</ng-template>
